// extracted by mini-css-extract-plugin
module.exports = {"click":"popup_click__CMOE8","close":"popup_close__OwHOE","content":"popup_content__AKP0h"};